import Router from 'vue-router'
import Vue from 'vue'

import Activities from '@/pages/Activities'
import Administration from '@/pages/Administration'
import ClientForm from '@/pages/ClientForm'
import Content from '@/pages/Content'
import Login from '@/pages/Login'
import Statistics from '@/pages/Statistics'

Vue.use Router

export default new Router
  mode: 'history'
  linkActiveClass: 'active'
  routes: [
      component: Login
      name: 'Login'
      path: '/login' 
    ,
      component: Content
      name: 'Content'
      path: '/'
      children: [
        component: ClientForm
        name: 'Start'
        path: 'start'
      ,
        component: Activities
        name: 'Activities'
        path: 'activities'
      ,
        component: Administration
        name: 'Administration'
        path: 'administration'
      ,
        component: Statistics
        name: 'Statistics'
        path: 'statistics'
      ]

  ]


// WEBPACK FOOTER //
// ./src/router/index.coffee